export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_10.5fd7f524.png";